import React from 'react';
import { BrowserRouter, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import { Security, LoginCallback } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';
import './index.css';
import PricingCalculatorWizardAllFeatures from './Pricing';
import PricingCalculatorWizard from './PricingBasic';
import PricingPackages from './PricingPackages';
import SecureRoute from './components/auth/SecureRoute';
import Login from './components/auth/Login';
import oktaAuth from './config/oktaConfig';
import reportWebVitals from './reportWebVitals';

// Main App component with routes
const App = () => {
  const navigate = useNavigate();

  // Callback for handling redirect after authentication
  const restoreOriginalUri = (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  };

  // Custom auth handler
  const customAuthHandler = () => {
    navigate('/login');
  };

  return (
    <Security 
      oktaAuth={oktaAuth}
      restoreOriginalUri={restoreOriginalUri}
      onAuthRequired={customAuthHandler}
    >
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/callback" element={<LoginCallback />} />
        <Route
          path="/pricing"
          element={
            <SecureRoute>
              <PricingCalculatorWizardAllFeatures />
            </SecureRoute>
          }
        />
        <Route
          path="/pricing-basic"
          element={
            <SecureRoute>
              <PricingCalculatorWizard />
            </SecureRoute>
          }
        />
        <Route
          path="/pricing-packages"
          element={
            <SecureRoute>
              <PricingPackages />
            </SecureRoute>
          }
        />
        <Route path="/" element={<Navigate to="/pricing" replace />} />
      </Routes>
    </Security>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();